import React, { FC } from 'react';
import { HotelTarget } from '~Hooks';
import { Box } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import HotelRoomIcon from '~Assets/icons/hotel-room.svg';
import { HotelChargeTargetKind } from '../../../../../../../__queries__/globalTypes';

interface Props {
  target: HotelTarget;
  color?: string;
}

/** Room number with a door icon in front; company accounts show their number without it. */
const RoomNumber: FC<Props> = ({ target, color = 'var(--colorBlueGray300)' }) => {
  const isRoom = target.input.kind === HotelChargeTargetKind.RESERVATION;

  return (
    <Box display="flex" alignItems="center" gap="xs" style={{ flexShrink: 0 }}>
      {isRoom && <Icon src={HotelRoomIcon} color={color} width="18px" height="18px" />}
      <Paragraph level={2} fontWeight={600} color={color}>
        {target.room}
      </Paragraph>
    </Box>
  );
};

export default RoomNumber;
